<template>
    <main-dialog
        ref="dialog"
        heading="planning.promotionsMaintenance.offer.offerGroup.motherProductSelector.header"
        btn-confirm-text="actions.select"
        title-text-align="left"
        :has-activator="false"
        :confirm-btn-disabled="!hasChanges"
        @confirm="confirm"
        @close="close"
    >
        <template v-slot:default>
            <div class="mother-product-selector">
                <p class="mother-product-selector__hint">
                    {{ toSentenceCase($tkey('hint')) }}
                </p>
                <div
                    v-for="option in options"
                    :key="option.productKey"
                    class="mother-product-selector__option"
                >
                    <v-checkbox
                        v-model="selectedKeys"
                        :value="option.productKey"
                        :disabled="option.disabled"
                        :label="option.label"
                        density="compact"
                        hide-details
                    />
                </div>
            </div>
        </template>
    </main-dialog>
</template>

<script setup>
import { computed, ref } from 'vue';
import { toSentenceCase } from '@/js/utils/string-utils';
import { getMotherSelectionChanges } from '@/js/pages/planning/utils/mother-product-utils';

defineOptions({
    localizationKey: 'planning.promotionsMaintenance.offer.offerGroup.motherProductSelector',
});

defineProps({
    options: {
        type: Array,
        default: () => [],
    },
});
const emit = defineEmits(['confirm']);

const dialog = ref(null);
const initialKeys = ref([]);
const selectedKeys = ref([]);

const changes = computed(() => getMotherSelectionChanges(initialKeys.value, selectedKeys.value));
const hasChanges = computed(
    () => changes.value.toSelect.length > 0 || changes.value.toDeselect.length > 0
);

const openDialog = keys => {
    initialKeys.value = [...keys];
    selectedKeys.value = [...keys];
    dialog.value.open();
};

const confirm = () => {
    emit('confirm', changes.value);
    dialog.value.close();
};

const close = () => {
    selectedKeys.value = [...initialKeys.value];
};

defineExpose({ openDialog });
</script>

<style scoped lang="scss">
.mother-product-selector {
    min-width: 30rem;
    max-height: 30rem;
    overflow-y: auto;

    &__hint {
        margin-bottom: 0.5rem;
    }
}
</style>
